import { render } from "./cont_vkursi.vue?vue&type=template&id=87caefcc"
import script from "./cont_vkursi.vue?vue&type=script&lang=js"
export * from "./cont_vkursi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/users/profile/info/tabs/cont_vkursi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87caefcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87caefcc', __exports__)) {
    console.log('reload')
    api.reload('87caefcc', __exports__)
  }
  
  module.hot.accept("./cont_vkursi.vue?vue&type=template&id=87caefcc", () => {
    console.log('re-render')
    api.rerender('87caefcc', render)
  })

}


export default __exports__